import OrderPayout from "../../services/api/OrderPayout";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import getTdsCertificatesService from "../../services/api/TdsCertificates";

const handleError = (err) => {
  console.log("[handleError] Error in OrderPayout actions", err);
};

export const setTdsCertificates = (payload) => {
  return {
    type: ActionTypes.SET_TDS_CERTIFICATES,
    payload: payload,
  };
};

export const getTdsCertificates = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let queryParam = `delivery_driver_id=${driverId}`;
    const response = await getTdsCertificatesService.getTdsCertificates(
      queryParam
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setTdsCertificates(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
